import { createGlobalStyle } from 'styled-components';
import './assets/fonts/stylesheet.css';

export default createGlobalStyle`
  * {
      margin: 0;
      padding: 0;
      outline:0;
      box-sizing:border-box;
      font-family: work-sans, sans-serif; 
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  #root{
    margin: 0 auto;
    background-color: #f0f0f0;
    color: #818181;
    height: 100vh;
    padding-top: 30px;
    overflow: auto;
  }

  .App {
    text-align: center;
  }
  
  .App-logo {
    height: 40vmin;
    pointer-events: none;
  }
  
  @media (prefers-reduced-motion: no-preference) {
    .App-logo {
      animation: App-logo-spin infinite 20s linear;
    }
  }
  
  .App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
  }
  
  .App-link {
    color: #61dafb;
  }
  
  @keyframes App-logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

    /* Checkbox */
  .ant-checkbox-wrapper {
    .ant-checkbox .ant-checkbox-inner {
      border: 2px solid #073133;

      &:after {
        display: none;
      }
    }
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #00cffd;
    }
  }

  /* Radio */
  .ant-radio {
    .ant-radio-inner {
      border: 2px solid #073133;
    }

    &.ant-radio-checked {
      .ant-radio-inner {
        border-color: #073133;
        background-color: #00cffd;

        &::after {
          background-color: #00cffd;
        }
      }
    }
  }

  .ant-input {
    color: #818181;
    background-color: #f0f0f0;
  }

  .ant-radio-wrapper, .ant-form-item-label >label {
    color: #818181 !important;
  }
`;
